/* eslint-disable no-underscore-dangle  */
import {createCachedSelector} from 're-reselect'

import {
  SECTION_BANK_DETAILS,
  SECTION_DIRECT_DEBIT_ACCOUNT_DETAILS,
  SECTION_LEGAL_REPRESENTATIVES,
  SECTION_SELLER_TRADE_PARTNERS,
  SECTION_ULTIMATE_BENEFICIAL_OWNERS,
  SECTION_INTERMEDIARY_SHAREHOLDERS,
  SECTION_DIRECTORS,
} from '../../../constants/sections'
import {AppThunkAction} from '../../../types/redux'

import {
  aInitializeDirectDebitBankAccounts,
  selectDirectDebitBankAccountsArePending,
} from './direct-debit-accounts'
import {
  aInitializeSellerBankAccountItems,
  selectSellerBankAccountItemsArePending,
} from './seller-bank-accounts'
import {
  aInitializeSellerTradePartners,
  selectSellerTradePartnerItemsArePending,
} from './seller-trade-partners'
import {
  aInitializeBeneficialOwnerItems,
  selectBeneficialOwnerItemsArePending,
} from './beneficial-owners'
import {
  aInitializeLegalRepresentativeItems,
  selectLegalRepresentativeItemsArePending,
} from './legal-representatives'
import {aInitializeDirectorItems, selectDirectorItemsArePending} from './directors'
import {
  aInitializeIntermediaryShareholdersItems,
  selectIntermediaryShareholderItemsArePending,
} from './intermediary-shareholders'

export const selectNavigationItemsArePending = createCachedSelector(
  (state: any, sectionName: string) => sectionName,
  selectDirectDebitBankAccountsArePending,
  selectSellerTradePartnerItemsArePending,
  selectSellerBankAccountItemsArePending,
  selectLegalRepresentativeItemsArePending,
  selectBeneficialOwnerItemsArePending,
  selectIntermediaryShareholderItemsArePending,
  selectDirectorItemsArePending,
  (
    sectionName: string,
    directDebitAccountsArePending,
    sellerTradePartnerItemsArePending,
    sellerBankAccountItemsArePending,
    legalRepresentativeItemsArePending,
    beneficialOwnerItemsArePending,
    intermediaryShareholderItemsArePending,
    directorItemsArePending
  ) => {
    switch (sectionName) {
      case SECTION_DIRECT_DEBIT_ACCOUNT_DETAILS:
        return directDebitAccountsArePending
      case SECTION_SELLER_TRADE_PARTNERS:
        return sellerTradePartnerItemsArePending
      case SECTION_BANK_DETAILS:
        return sellerBankAccountItemsArePending
      case SECTION_LEGAL_REPRESENTATIVES:
        return legalRepresentativeItemsArePending
      case SECTION_ULTIMATE_BENEFICIAL_OWNERS:
        return beneficialOwnerItemsArePending
      case SECTION_INTERMEDIARY_SHAREHOLDERS:
        return intermediaryShareholderItemsArePending
      case SECTION_DIRECTORS:
        return directorItemsArePending
      default:
        return false
    }
  }
)((state, sectionName: string) => sectionName)

export const aInitializeDynamicNavigationItems =
  (sectionName: string): AppThunkAction<void> =>
  (dispatch): void => {
    switch (sectionName) {
      case SECTION_DIRECT_DEBIT_ACCOUNT_DETAILS:
        return dispatch(aInitializeDirectDebitBankAccounts())
      case SECTION_SELLER_TRADE_PARTNERS:
        return dispatch(aInitializeSellerTradePartners())
      case SECTION_BANK_DETAILS:
        return dispatch(aInitializeSellerBankAccountItems())
      case SECTION_LEGAL_REPRESENTATIVES:
        return dispatch(aInitializeLegalRepresentativeItems())
      case SECTION_ULTIMATE_BENEFICIAL_OWNERS:
        return dispatch(aInitializeBeneficialOwnerItems())
      case SECTION_INTERMEDIARY_SHAREHOLDERS:
        return dispatch(aInitializeIntermediaryShareholdersItems())
      case SECTION_DIRECTORS:
        return dispatch(aInitializeDirectorItems())
      default:
        return undefined
    }
  }
